import { render, staticRenderFns } from "./Transfer.vue?vue&type=template&id=583f2080&scoped=true&"
import script from "./Transfer.vue?vue&type=script&lang=ts&"
export * from "./Transfer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583f2080",
  null
  
)

export default component.exports